/**
 * @fileoverview React component that handles the tools panel
 *
 * @author Varun Vijayaraghavan (vvijayaraghavan@yext.com)
 */
goog.module('yext.m4.confcode.adminconsole.ToolsPanelComponent');

goog.require('yext.m4.confcode.adminconsole.ConsoleComponent');
goog.require('yext.m4.confcode.adminconsole.DiagnosticsComponent');


class ToolsPanelComponent extends React.Component {
  constructor(props) {
    super(props);

    this._switchToDiagnostics = this._switchToDiagnostics.bind(this);

    /**
     * Needed to check if we the diagnostics have changed, and the tab needs to be changed.
     *
     * Guards against a console component change that does not actually change the diagnostics.
     *
     * @type {!boolean}
     */
    this._handledChangedDiagnostics = false;

    /**
     * @type {!State}
     */
    this.state = {
      activeTab: 'Console',
    };

    /**
     * @type {!Props}
     */
    this.props;
  }

  /**
   * @suppress {strictCheckTypes}
   */
  componentDidUpdate(prevProps) {
    if (prevProps.diagnosticInfo.errors !== this.props.diagnosticInfo.errors) {
      if (!this.props.diagnosticInfo.errors.length) {
        // if there are no errors, but it was there previously, default the state to
        // console tab.
        this.setState({
          activeTab: 'Console',
        });
      } else {
        // Can't directly setState to display the diagnostics tab, because that can be
        // displayed only after the scrolling is complete.
        this._handledChangedDiagnostics = false;
      }
    }
  }

  _switchToDiagnostics() {
    if (!this.props.diagnosticInfo.errors.length) {
      return;
    }
    if (this._handledChangedDiagnostics) {
      return;
    }
    this.setState({
      activeTab: 'Diagnostics',
    });
    this._handledChangedDiagnostics = true;
  }

  render() {
    const DiagnosticsPanelComponent = goog.module.get('yext.m4.confcode.adminconsole.DiagnosticsComponent');
    const ConsoleComponent = goog.module.get('yext.m4.confcode.adminconsole.ConsoleComponent');
    return [
      // eslint-disable-next-line
      <ul className="nav nav-tabs" id="tools-tab" role="tablist">
        <li className="nav-item">
          <a
            onClick={() => this.setState({activeTab: 'Console'})}
            className={this.state.activeTab === 'Console' ? 'nav-link active' : 'nav-link'}
            id="console-tab" data-toggle="tab" href="#tools-console"
            role="tab"
          >
            Console
          </a>
        </li>
        <li className="nav-item">
          <a
            className={this.state.activeTab === 'Diagnostics' ? 'nav-link active' : 'nav-link'}
            id="diagnostics-tab"
            data-toggle="tab"
            onClick={() => this.setState({activeTab: 'Diagnostics'})}
            href="#tools-diagnostics"
            role="tab"
          >
            Errors / Warnings
          </a>
        </li>
      </ul>,
      // eslint-disable-next-line
      <div className="tab-content" id="tools-content">
        <ConsoleComponent
          active={this.state.activeTab === 'Console'}
          lines={this.props.consoleLines}
          onTextRender={this._switchToDiagnostics}
        ></ConsoleComponent>
        <DiagnosticsPanelComponent
          active={this.state.activeTab === 'Diagnostics'}
          diagnosticInfo={this.props.diagnosticInfo}
        ></DiagnosticsPanelComponent>
      </div>,
    ];
  }
}

/** @record */
class Line {
  constructor() {
    /** @type {!string} */
    this.type;

    /** @type {?string} */
    this.meta;

    /** @type {!string} */
    this.text;
  }
}

/** @record */
class DiagnosticInfo {
  constructor() {
    /**
     * @type {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>}
     */
    this.warnings;

    /**
     * @type {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>}
     */
    this.errors;
  }
}

/** @record */
class Props {
  constructor() {
    /**
     * The output to display in the console.
     * @type {!Array<!Line>}
     */
    this.consoleLines;

    /**
     * @type {!DiagnosticInfo}
     */
    this.diagnosticInfo;
  }
}

/** @record */
class State {
  constructor() {
    /**
     * The current active tab.
     * @type {!string}
     */
    this.activeTab;
  }
}


exports = ToolsPanelComponent;
